import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { DashboardComponent } from "./components/dashboard.component";

import { FormsModule } from "@angular/forms";
import { AppSharedModule } from "../../shared/app-shared.module";
import { TodaySuspensionComponent } from "./todaysuspension/todaysuspension.component";
import { AccordionModule } from "primeng/accordion";
import { ScrollPanelModule } from "primeng/scrollpanel";
import { ChartModule } from "primeng/chart";
import { OrderListModule } from "primeng/orderlist";
import { TableModule } from "primeng/table";
import { DropdownModule } from "primeng/dropdown";

import { SchoolselectorModule } from "../schoolselector/schoolselector.module";

import { DashboardService } from "./dashboard.service";

import { StudentDashboardAttendanceComponent } from "./studentdashboardattendance/studentdashboardattendance.component";
import { StudentBehaviorComponent } from "./studentbehavior/studentbehavior.component";
import { TodaysEventsComponent } from "./todays-events/todays-events.component";
import { TodaysReleasesComponent } from "./todays-releases/todays-releases.component";

@NgModule({
	declarations: [
		DashboardComponent,
		TodaySuspensionComponent,
		StudentDashboardAttendanceComponent,
		StudentBehaviorComponent,
		TodaysEventsComponent,
		TodaysReleasesComponent,
	],
	imports: [
		CommonModule,
		FormsModule,
		AppSharedModule,
		AccordionModule,
		ScrollPanelModule,
		ChartModule,
		OrderListModule,
		TableModule,
		DropdownModule,
		SchoolselectorModule,
	],
	providers: [DashboardService],
})
export class DashboardModule {}
